import BaseApi from './BaseApi';

type ChatUser = { userId: string; email: string; displayName: string };

/**
 * 会員検索API。
 */
class GetKaiinChatAvailableChatUserListApi extends BaseApi {
  async getAvailableUsers(search = '') {
    return await this.execute('getKaiinChatAvailableChatUserListApi', {
      method: 'POST',
      body: { searchUserName: search }
    }).then(({ result }) => result.userList as ChatUser[]);
  }
}

export default GetKaiinChatAvailableChatUserListApi;
